import { render, staticRenderFns } from "./Brainstorm.vue?vue&type=template&id=28498aee&scoped=true&"
import script from "./Brainstorm.vue?vue&type=script&lang=js&"
export * from "./Brainstorm.vue?vue&type=script&lang=js&"
import style0 from "./Brainstorm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Brainstorm.vue?vue&type=style&index=1&id=28498aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28498aee",
  null
  
)

export default component.exports